var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zoom_out_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/zoom_out_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0065 19.0067H19.9532L19.5798 18.6467C20.8865 17.1267 21.6732 15.1534 21.6732 13.0067C21.6732 8.22003 17.7932 4.34003 13.0065 4.34003C8.21984 4.34003 4.33984 8.22003 4.33984 13.0067C4.33984 17.7934 8.21984 21.6734 13.0065 21.6734C15.1532 21.6734 17.1265 20.8867 18.6465 19.58L19.0065 19.9534V21.0067L25.6732 27.66L27.6598 25.6734L21.0065 19.0067ZM13.0065 19.0067C9.68651 19.0067 7.00651 16.3267 7.00651 13.0067C7.00651 9.68669 9.68651 7.00669 13.0065 7.00669C16.3265 7.00669 19.0065 9.68669 19.0065 13.0067C19.0065 16.3267 16.3265 19.0067 13.0065 19.0067ZM16.3398 12.34H9.67318V13.6734H16.3398V12.34Z",
    fill: "inherit",
    fillOpacity: 0.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.80a007e7223cfc60ca5b87b908ff5dd8.svg";
export { ForwardRef as ReactComponent };